import { Directive, ViewContainerRef } from '@angular/core';
// ---------------------------------------------------------------------------
@Directive({
  selector: '[addHost]',
})
export class ContractStateDirective {
  constructor(public viewContainerRef: ViewContainerRef) { 
    
  }
}
